// extracted by mini-css-extract-plugin
export default {"sideBarPaper":"style_sideBarPaper__gkAqB"};